exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".playkit-ads-cover {\n  position: relative;\n  cursor: pointer;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.playkit-ads-container {\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n}\n", ""]);

